import React, { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import logo from '../img/nekrodruk-logo-dark.png';

const ProtectedRoute = ({ element: Component, adminOnly = false, allowWithoutConsent = false, allowWithoutSubscription = false, ...rest }) => {
    const { isLoggedIn, isAdmin, isLoading, activeSubscription, needsConsents } = useAuth();
    const [isAuthorized, setIsAuthorized] = useState(null);
    const location = useLocation();

    useEffect(() => {
      if (!isLoading) {
          if (isLoggedIn === false || (adminOnly && !isAdmin)) {
              setIsAuthorized(false);
          } else {
              setIsAuthorized(true);
          }
      }
  }, [isLoggedIn, isAdmin, adminOnly, isLoading]);

    if (isLoading || isAuthorized === null) {
      return (
        <section className='loading_section'>
          <img src={logo} alt='loading_logo' className='loading_logo' />
          <span className="loader"></span>
        </section>
      );
    }

    if (!isAuthorized) {
        return <Navigate to={isLoggedIn ? "/" : "/login"} />;
    }

    if (!allowWithoutConsent && needsConsents) {
        return <Navigate to="/consents" replace />;
    }

    if (allowWithoutConsent && !needsConsents && location.pathname === '/consents') {
        return <Navigate to="/personForm" replace />;
    }

    if (!allowWithoutSubscription && !activeSubscription && !isAdmin) {
        return <Navigate to="/subscription-expired" replace />;
    }

    return <Component {...rest} />;
};

export default ProtectedRoute;
